import { useEffect } from "react";

/**
 * Updates document <title>, meta description, canonical and Open Graph
 * url/title/description on route change. Falls back gracefully if the
 * tags don't exist.
 */
export default function useDocumentMeta({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, attr, value) => {
      const el = document.head.querySelector(selector);
      if (el && value != null) el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }

    if (title) {
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }

    if (path) {
      const canonical = `https://autoszerelem.hu${path}`;
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
      setMeta('meta[property="og:url"]', "content", canonical);
    }
  }, [title, description, path]);
}
